export class SearchedInfo {
  formattedAddress: string;

  // @ts-ignore
  location: google.maps.LatLng;

  // @ts-ignore
  viewport: google.maps.LatLngBounds;

  // @ts-ignore
  fromPlaceResult(place: google.maps.places.PlaceResult): SearchedInfo {
    this.formattedAddress = place.formatted_address;
    this.location = place.geometry.location;
    this.viewport = place.geometry.viewport;
    return this;
  }

  // @ts-ignore
  fromGeocoderResult(geocoderResult: google.maps.GeocoderResult): SearchedInfo {
    this.formattedAddress = geocoderResult.formatted_address;
    this.location = geocoderResult.geometry.location;
    this.viewport = geocoderResult.geometry.viewport;
    return this;
  }
}
